import { GAME_IDS } from '../config'
import { GameID } from '../types'
import { useEffect, useRef, useState } from 'react'
import Timings, {
	daily5ArchiveTimings,
	daily5Timings,
	TIMINGS_CHANGED,
} from '../controllers/timings'

export const useTimings = (gameid: GameID): Timings => {
	const timings = gameid === GAME_IDS.DAILY5 ? daily5Timings : daily5ArchiveTimings

	// An internal state to force rerendering when data changes
	// The actual "timings" object is a singleton, so it doesn't change, and won't trigger rerendering
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [, setRerender] = useState(0)
	const renderNum = useRef(0)

	useEffect(() => {
		timings.load(gameid)
		const triggerRerender = () => {
			renderNum.current += 1
			setRerender(renderNum.current)
		}
		timings.on(TIMINGS_CHANGED, triggerRerender)
		return () => timings.off(TIMINGS_CHANGED, triggerRerender)
	}, [])

	return timings
}
